import EditIcon from "@/assets/icons/EditIcon.svg";
import { Button } from "@/components/ui/button"
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog"
import { Input } from "@/components/ui/input"
import i18n from "@/lang/i18n";
import { Form, FormControl, FormField, FormItem, FormMessage } from "../ui/form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useState } from "react";

interface EditCardValuesDialogProps {
    title: string,
    fieldName: string,
    placeholder: string,
    fieldType: string,
    defaultValue: string,
    inputPrependText: string,
    formSchema: z.ZodObject<any, any, any>,
    handleSubmit: (data: z.infer<any>) => void,
    disabled: boolean,
}

const EditCardValuesDialog: React.FC<EditCardValuesDialogProps> = ({ title, fieldName, placeholder, fieldType, defaultValue, inputPrependText, formSchema, handleSubmit, disabled = false }) => {

    const [open, setOpen] = useState(false);

    const form = useForm({
        resolver: zodResolver(formSchema),
    });

    const onSubmit = (data: z.infer<typeof formSchema>) => {
        handleSubmit(data);
        setOpen(false);
    };

    return (
        <Dialog open={open} onOpenChange={(_open) => setOpen(_open)}>
            <DialogTrigger asChild>
                <Button disabled={disabled} variant="ghost" size="xs">
                    <img className="inline" alt="edit" src={EditIcon} />
                </Button>
            </DialogTrigger>
            <DialogContent className="w-2/3 rounded-[15px]">
                <DialogHeader>
                    <DialogTitle className="text-primary">{title}</DialogTitle>
                </DialogHeader>

                <Form {...form}>
                    <form onSubmit={form.handleSubmit(onSubmit)} className="w-full">
                        <FormField
                            control={form.control}
                            name={fieldName}
                            render={({ field }) => (
                                <FormItem>
                                    <div className="flex items-center">
                                        <FormControl>
                                            <Input
                                                type={fieldType}
                                                defaultValue={defaultValue}
                                                className="bg-transparent text-secondary placeholder-secondary"
                                                placeholder={placeholder}
                                                {...field}
                                            />
                                        </FormControl>
                                        <p className="pl-2 text-secondary">{inputPrependText}</p>
                                    </div>
                                    <FormMessage />
                                </FormItem>
                            )}
                        />
                        <DialogClose asChild>
                            <Button className="mt-3" variant="secondary" type="submit">
                                {i18n.t('confirm')}
                            </Button>
                        </DialogClose>
                    </form>
                </Form>
            </DialogContent>
        </Dialog>
    )
}

export default EditCardValuesDialog;